@if (!addNewDealer) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title"> Dealer Master</span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        @if (dealerMasterCreate) {
          <button
            class="primary-button"
            type="button"
            (click)="addNewDealerFunc()"
          >
            Add Dealer
            <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="component-container">
      <!-- List Section -->
      <form [formGroup]="dealerMasterForm">
        <!-- Dealer List Section -->
        <div class="component-header">
          <h6 class="component-title">Dealer List</h6>
          <div class="component-actions">
            <button
              type="button"
              class="primary-button"
              [disabled]="dealerList.length === 0 || isDownloading"
              (click)="downloadDealerMasterData()"
            >
              Download Dealer Master Details<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
            <app-common-search
              [initialSearchValue]="
                dealerMasterSearchForm?.get('searchDealer')?.value
              "
              matTooltip="POS Code | POS Name | Dealer Code | Mobile NO."
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <tr>
              <!-- <th>User Id</th> -->
              <th>POS Code</th>
              <th>POS Name</th>
              <th>Dealer Code</th>
              <th>Mobile NO.</th>
              <th>State</th>
              @if (dealerMasterUpdate && dealerMasterDelete) {
                <th>Action</th>
              }
            </tr>
            @if (dealerList.length !== 0) {
              <tbody>
                @for (
                  dealer of dealerList
                    | paginate
                      : {
                          id: 'user_pagination',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track dealer
                ) {
                  <tr>
                    <td>
                      {{ dealer.posCode }}
                    </td>
                    <td>
                      {{ dealer.posName }}
                    </td>
                    <td>
                      {{ dealer.dealercode }}
                    </td>
                    <td>
                      {{ dealer.mobile }}
                    </td>
                    <td>
                      {{ dealer.state }}
                    </td>
                    @if (dealerMasterUpdate || dealerMasterDelete) {
                      <td>
                        <div class="action-buttons">
                          @if (dealerMasterUpdate) {
                            <button
                              type="button"
                              class="primary-button view-button"
                              (click)="prePopulation(dealer._id)"
                            >
                              <mat-icon class="btn-icon">visibility</mat-icon>
                            </button>
                          }
                          @if (dealerMasterDelete) {
                            <button
                              type="button"
                              class="primary-button delete-button"
                              (click)="deleteDealer(dealer._id)"
                            >
                              <mat-icon class="btn-icon">delete</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            }
            @if (dealerList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (totalLength !== 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </form>
    </div>
  </div>
}

<!-- Add/Edit Dealer Form Section -->
@if (addNewDealer) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="cancelFunc()"
          tabindex="0"
          (keydown.enter)="cancelFunc()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="prePopulation(selectedDealerId)"
          tabindex="0"
          (keydown.enter)="prePopulation(selectedDealerId)"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title"> Add/Edit Dealer</span>
      </div>
    </div>

    <div class="component-container">
      <form [formGroup]="dealerMasterForm" novalidate>
        <!-- List Section -->
        <div class="component-header">
          <h6 class="component-title">
            {{ editMode ? 'Edit Dealer' : 'Add New Dealer' }}
          </h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="dealercode" class="form-label">Dealer Code</label>
              <mat-form-field appearance="outline">
                <mat-label>Dealer Code</mat-label>
                <input
                  matInput
                  id="dealercode"
                  type="text"
                  placeholder="Dealer Code"
                  formControlName="dealercode"
                  required
                />
                @if (
                  dealerMasterForm.controls['dealercode'].touched &&
                  dealerMasterForm.controls['dealercode'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['dealercode'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="posCode" class="form-label">POS Code</label>
              <mat-form-field appearance="outline">
                <mat-label>POS Code</mat-label>
                <input
                  matInput
                  id="posCode"
                  type="text"
                  placeholder="POS Code"
                  formControlName="posCode"
                  required
                />
                @if (
                  dealerMasterForm.controls['posCode'].touched &&
                  dealerMasterForm.controls['posCode'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['posCode'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="posName" class="form-label">POS Name</label>
              <mat-form-field appearance="outline">
                <mat-label>POS Name</mat-label>
                <input
                  matInput
                  id="posName"
                  type="text"
                  placeholder="POS Name"
                  formControlName="posName"
                  required
                />
                @if (
                  dealerMasterForm.controls['posName'].touched &&
                  dealerMasterForm.controls['posName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['posName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="mobile" class="form-label">Mobile Number</label>
              <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input
                  matInput
                  id="mobile"
                  type="number"
                  placeholder="Mobile Number"
                  formControlName="mobile"
                  required
                />
                @if (
                  dealerMasterForm.controls['mobile'].touched &&
                  dealerMasterForm.controls['mobile'].errors
                    ?.mobileNumberValidation
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['mobile'].errors
                        ?.mobileNumberValidation
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="state" class="form-label">State</label>
              <mat-form-field appearance="outline">
                <mat-label>State</mat-label>
                <mat-select #stateSelect formControlName="state">
                  @if (stateSelect.focused) {
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="stateNameFilterCtrl"
                        [noEntriesFoundLabel]="'No options found'"
                        placeholderLabel="Filter"
                        (filteredReturn)="stateList = $event"
                      >
                      </ngx-mat-select-search>
                    </mat-option>
                  }
                  @for (item of stateList; track item) {
                    <mat-option [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  dealerMasterForm.controls['state'].touched &&
                  dealerMasterForm.controls['state'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['state'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="city" class="form-label">City</label>
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input
                  matInput
                  id="city"
                  type="text"
                  placeholder="City"
                  formControlName="city"
                  required
                />
                @if (
                  dealerMasterForm.controls['city'].touched &&
                  dealerMasterForm.controls['city'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['city'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-group">
              <label for="email" class="form-label">Email</label>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  id="email"
                  type="email"
                  placeholder="Email"
                  formControlName="email"
                  required
                />
                @if (
                  dealerMasterForm.controls['email'].touched &&
                  dealerMasterForm.controls['email'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      dealerMasterForm.controls['email'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  dealerMasterForm.controls['email'].touched &&
                  dealerMasterForm.controls['email'].errors?.validEmail
                ) {
                  <mat-error>
                    {{ dealerMasterForm.controls['email'].errors?.validEmail }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <!-- Component Footer Section (Optional) -->
          <div class="component-footer">
            <div class="button-group">
              @if (dealerMasterCreate && dealerMasterUpdate) {
                <button
                  type="button"
                  (click)="save()"
                  [ngClass]="editMode ? 'edit-button' : 'submit-button'"
                >
                  {{ editMode ? 'Update ' : 'Save ' }}
                  Dealer Details
                  <mat-icon class="btn-icon">{{
                    editMode ? 'edit' : 'check_circle'
                  }}</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
}
